
<!-- <app-academic-headers></app-academic-headers> -->

<body id="body">
    <div id="searchContainer">
        <input type="text" id="input" placeholder="Enter admission number">
        <i class="fa fa-search" id="search" aria-hidden="true" (click)="search()"></i>
    </div>
    <div *ngIf="showComponent">
        <app-student-progress-report #StudentProgressReportComponent></app-student-progress-report>
    </div>
    <div id="notfoundContainer" *ngIf="!showComponent">
        <div class="notfound">
            <h1 *ngIf="notfirstTime">No student details  found </h1>
        </div>

    </div>
    <!-- ================== loader ==================-->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

</body>
<!-- <app-academic-footers></app-academic-footers> -->

